import asyncWrapper from "/src/utils/asyncWrapper";

const fetchWrapper = (url, options) => asyncWrapper(fetchMethod, url, options);

const fetchMethod = (url, options) => new Promise((resolve, reject) => {
    var status;
    fetch(url, options)
    .then(response => {
        status = response.status
        return response.json();
    })
    .then(body => status === 200 || status === 201 ? resolve(body) : reject(body))
    .catch(err =>  {
        if(navigator.onLine == false) {
            return;
        }
        
        reject(err)
    });
});

export default fetchWrapper;